module.exports = __webpack_public_path__ + "static/media/cbeTeletrainingVideoPic.dadb3bff.png";